class VideoModal {
    constructor(el) {
        this.scope = el;
        this.trigger = el.querySelector("[data-trigger]");
        this.video = el.querySelector("[data-video]");
        this.videoWrapper = el.querySelector("[data-video-wrapper]");
        this.modal = el.querySelector("[data-modal]");
        this.player = null; // Player reference for YouTube
        this.bindEvents();
    }

    bindEvents() {
        this.trigger.addEventListener("click", () => this.playVideo());
    }

    playVideo() {
        console.log("play video");
        this.videoWrapper.classList.remove("opacity-0", "-z-10");
        if (this.video.tagName === "IFRAME") {
            VideoModal.playExternalVideo(this.video, (player) => {
                this.player = player;
                if (this.player && typeof this.player.playVideo === 'function') {
                    this.player.playVideo();
                }
            });
        } else {
            VideoModal.playHTML5Video(this.video);
        }
    }

    stopVideo() {
        if (this.video.tagName === "IFRAME") {
            VideoModal.stopExternalVideo(this.player);
        } else {
            this.stopHTML5Video();
        }
    }

    static async playHTML5Video(video) {
        try {
            await video.play();
        } catch (err) {
            console.log("Error playing HTML5 video:", err);
        }
    }

    static playExternalVideo(video, callback) {
        if (!window.YT || !window.YT.Player) {
            VideoModal.loadYouTubeAPI(() => {
                VideoModal.initializeYouTubePlayer(video, callback);
            });
        } else {
            if (!video.dataset.playerInitialized) {
                VideoModal.initializeYouTubePlayer(video, callback);
            } else {
                const player = VideoModal.getYouTubePlayerInstance(video);
                if (callback) callback(player);
            }
        }
    }

    stopHTML5Video() {
        this.video.pause();
        this.video.currentTime = 0;
    }

    static stopExternalVideo(player) {
        if (player && typeof player.stopVideo === 'function') {
            player.stopVideo();
        }
    }

    static loadYouTubeAPI(callback) {
        if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
            window.onYouTubeIframeAPIReady = callback;
            return;
        }

        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        window.onYouTubeIframeAPIReady = callback;
    }

    static initializeYouTubePlayer(video, callback) {
        const player = new YT.Player(video, {
            events: {
                'onReady': (event) => {
                    if (callback) callback(event.target);
                }
            }
        });
        video.dataset.playerInitialized = true;
        video.dataset.playerInstanceId = player.getIframe().id; // Store the player instance ID
    }

    static getYouTubePlayerInstance(video) {
        const playerInstanceId = video.dataset.playerInstanceId;
        return window.YT.get(playerInstanceId);
    }
}

document.querySelectorAll("[data-video-block]").forEach(videoBlock => new VideoModal(videoBlock));
